export default [
  {
    path: "login",
    name: "login",
    component: () => import("pages/LoginPage.vue"),
  },
  {
    path: "register",
    name: "register",
    component: () => import("pages/RegisterForm.vue"),
  },
  {
    path: "pending-approval",
    name: "pending-approval",
    component: () => import("pages/PendingApproval.vue"),
  },
  {
    path: "email-confirmed",
    name: "email-confirmed",
    component: () => import("pages/EmailConfirmed.vue"),
  },
  {
    path: "complete-profile",
    name: "complete-profile",
    component: () => import("pages/CompleteProfile.vue"),
  },
  {
    path: "reset-confirm",
    name: "reset-confirm",
    component: () => import("pages/ResetConfirm.vue"),
  },
];
